/* Nolae — Searchanise "Hinzugefügt" resets like the homepage (user, 2026-10-13).
 *
 * On the homepage, an add-to-cart button shows "Hinzugefügt" for 3s, then
 * goes back to "Hinzufügen" so the item can be added again. Searchanise's
 * result buttons instead stay in a "view cart" state after adding: they get
 * the class `size-button-view-cart`, lose their + icon, read "Hinzugefügt",
 * and a second click opens the cart. This puts them back after the same 3s:
 * the class comes off (Searchanise reads it to decide add vs view-cart) and
 * the button's original contents — icon + label in the shop's language,
 * saved at the click — are restored.
 *
 * Loaded from layout/theme.liquid; does nothing on pages without
 * Searchanise results. Framework-free IIFE.
 */
(function () {
  "use strict";
  var ADDED = "size-button-view-cart";
  var BTN = ".snize-add-to-cart-button";
  var DELAY = 3000; // the homepage keeps "Hinzugefügt" for 3s
  var original = new WeakMap();

  // Save each button's contents as it is clicked, before Searchanise
  // rewrites them (capture phase runs ahead of its own handler).
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest(BTN);
    if (b && !b.classList.contains(ADDED)) original.set(b, b.innerHTML);
  }, true);

  function reset(b) {
    if (!b.isConnected || !b.classList.contains(ADDED)) return;
    b.classList.remove(ADDED);
    b.removeAttribute("disabled");
    if (original.has(b)) b.innerHTML = original.get(b);
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var b = records[i].target;
      if (b.nodeType === 1 && b.matches(BTN) && b.classList.contains(ADDED) && !b.__nolaeReset) {
        b.__nolaeReset = true;
        setTimeout(function (btn) { btn.__nolaeReset = false; reset(btn); }, DELAY, b);
      }
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ["class"] });
})();
